import { render, staticRenderFns } from "./EternityChallengeBox.vue?vue&type=template&id=40461f49&scoped=true"
import script from "./EternityChallengeBox.vue?vue&type=script&lang=js"
export * from "./EternityChallengeBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40461f49",
  null
  
)

export default component.exports